import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SessionProvider } from "./context/SessionContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Intake from "./pages/Intake";
import Upload from "./pages/Upload";
import PathwayScreen from "./pages/PathwayScreen";
import Vision from "./pages/Vision";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import ProjectReturn from "./pages/ProjectReturn";
import AdminVerify from "./pages/AdminVerify";
import AuthCallback from "./pages/AuthCallback";
import PrintConversation from "./pages/PrintConversation";
import ReportView, { ReportSuccess } from "./pages/ReportView";
import CardSuccess from "./pages/CardSuccess";

function Router() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  // Detect OAuth callback fragment synchronously during render (handles race conditions).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/intake" element={<Intake />} />
      <Route path="/upload" element={<Upload />} />
      <Route path="/diagnose" element={<PathwayScreen mode="diagnose" />} />
      <Route path="/improve" element={<PathwayScreen mode="improve" />} />
      <Route path="/vision" element={<Vision />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/verify" element={<AdminVerify />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/project/:token" element={<ProjectReturn />} />
      <Route path="/case/:sessionId/print" element={<PrintConversation />} />
      <Route path="/report/success" element={<ReportSuccess />} />
      <Route path="/card/success" element={<CardSuccess />} />
      <Route path="/report/:reportId" element={<ReportView />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SessionProvider>
          <BrowserRouter>
            <Router />
            <Toaster
              position="top-center"
              richColors
              closeButton
              toastOptions={{
                style: { fontFamily: "Plus Jakarta Sans, sans-serif" },
              }}
            />
          </BrowserRouter>
        </SessionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
